import * as React from "react";
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 24679 24679"
    {...props}
  >
    <defs>
      <style>
        {/* {".str0{stroke:#2b2a29;stroke-width:1207.72}.fil0{fill:none}"} */}
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <circle
        cx={12340}
        cy={12340}
        r={11735}
        className="stroke1 fill-none"
        style={{
          strokeWidth: 1207.72,
        }}
      />
      <circle
        cx={12340}
        cy={12340}
        r={9060}
        className="stroke1 fill-none"
        style={{
          strokeWidth: 1207.72,
        }}
      />
      <circle
        cx={12340}
        cy={12340}
        r={1726}
        style={{
          fill: "#2b2a29",
        }}
        className="fill"
      />
    </g>
  </svg>
);
export default SvgComponent;
